import React from 'react'
import Header from './include/Header'
import Footer from './include/Footer'
import WhatsAppSupport from './include/WhatsAppSupport'

function Base({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
      <WhatsAppSupport />
    </>
  )
}

export default Base
